module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#share",
      toString: function () {
        return this.url;
      }
    }